import { StaticQuery, graphql } from 'gatsby'

import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
// ArComponents
import ArBlogHeader from 'src/components/blog/ArBlogHeader/ArBlogHeader'
import ArBlogItemsList from 'src/components/blog/ArBlogItemsList/ArBlogItemsList'
import ArBlogItemsTypeSelector from 'src/components/blog/ArBlogItemsTypeSelector/ArBlogItemsTypeSelector'
import ArBlogPromoPost from 'src/components/blog/ArBlogPromoPost/ArBlogPromoPost'
import ArMailingListForm from 'src/components/ArMailingListForm/ArMailingListForm'
import ArSeo from 'src/components/ArSeo/ArSeo'
import DaPageBlog from 'src/data/PageBlog'
import React from 'react'
import deviceInfoProvider from 'src/utils/deviceInfoProvider'
import { media } from 'src/styles/styled-components'
import routesConfig from 'src/routes.config'
import styled from 'styled-components'

const StyledButtonWrapper = styled.div`
  margin: 0 auto;
  max-width: 325px;
  padding: 0 0 40px;
  width: 100%;

  ${ media.tablet`
    width: 250px;
    padding: 40px 0 80px;
  ` }

  ${ media.desktop`
    padding-bottom: 100px;
  ` }
`

const StyledButton = styled(ArBaseButton)`
  margin: 0 auto;
`

class BlogPage extends React.Component {
  articles = []
  pressReleases = []
  state = {
    itemsType: 'article',
    currentPage: 1,
    itemsPerPage: this.articlesPerPage,
  }

  componentDidMount () {
    this.setState({
      itemsPerPage: this.articlesPerPage,
    })
  }

  get articlesPerPage () {
    return this.props.device.isDesktop ? 6 : 4
  }

  get pressReleasesPerPage () {
    return !this.props.device.isDesktop ? 4 : 6
  }

  setBlogItemsData (data) {
    if (!data.articles) return []
    const { edges } = data.articles

    const arr = edges.reduce((acc, { node: item }) => {
      if (!item.isPressRelease) {
        const article = {
          slug: item.slug,
          title: item.title && item.title.title,
          description: item.description && item.description.description,
          category: item.category ? item.category[0].title : 'no title',
          author: Array.isArray(item.author) ? item.author.map(author => ({
            name: author.name || 'no author',
            image: author?.profilePhoto?.file?.url || '',
          })) : [{
            name: item.author ? item.author[0].name : 'no author',
            image: item.author ? item.author[0].profilePhoto ? item.author[0].profilePhoto.file.url : '' : '',
          }],
          thumbnail: {
            name: item.featuredImage ? item.featuredImage.title : 'no image title',
            url: item.featuredImage ? item.featuredImage.file.url : '',
          },
        }

        acc[0].push(article)
      } else {
        const pressReleases = {
          slug: item.slug,
          date: item.date,
          title: item.title && item.title.title,
        }

        acc[1].push(pressReleases)
      }

      return acc
    }, [[], []])

    this.articles = arr[0]
    this.pressReleases = arr[1]
  }

  _setItemsType (type) {
    this.setState({
      itemsType: type || 'article',
      itemsPerPage: type === 'article' ? this.articlesPerPage : this.pressReleasesPerPage,
    })
  }

  _loadMorePosts () {
    if (this.canLoadMorePosts) {
      this.setState(state => ({
        currentPage: state.currentPage + 1,
      }))
    }
  }

  get canLoadMorePosts () {
    return this.state.currentPage * this.state.itemsPerPage < this.activeItems.length
  }

  get activeItems () {
    return this.state.itemsType === 'article' ? this.articles : this.pressReleases
  }

  get _blogItems () {
    return this.activeItems.slice(0, this.state.currentPage * this.state.itemsPerPage)
  }

  _renderBlogLayout (data) {
    if (this.articles.length === 0) this.setBlogItemsData(data)
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageBlog.metadata.title}
          description={DaPageBlog.metadata.desc}
          path={routesConfig.company.blog()}
        />

        {!this.props.device.isMobile && <ArBlogHeader />}
        <ArBaseContainer scClear={true}>
          {!this.props.device.isMobile && <ArBlogPromoPost />}
          <ArBlogItemsTypeSelector onTypeSelect={this._setItemsType.bind(this)} activeType={this.state.itemsType} />
          <ArBlogItemsList itemsType={this.state.itemsType} items={this._blogItems} />
          {/* {this.canLoadMorePosts && <button onClick={() => this._loadMorePosts()}>__++++__</button>} */}
          {this.canLoadMorePosts &&
          <StyledButtonWrapper>
            <StyledButton
              label="Load More"
              variant="purple"
              onClick={() => this._loadMorePosts()}
            />
          </StyledButtonWrapper>}
        </ArBaseContainer>
        <ArMailingListForm />
      </React.Fragment>
    )
  }

  render () {
    return (
      <StaticQuery
        query={query}
        render={this._renderBlogLayout.bind(this)}
      />
    )
  }
}

const query = graphql`
  query BlogItemsQuery {
    articles: allContentfulPost(sort: {
      fields: [createdAt]
      order: DESC
    }) {
      edges {
        node {
          id
          slug
          title {
            title
          }
          description {
            description
          }
          featuredImage {
            file {
              url
            }
            title
          }
          author {
            id
            name
            profilePhoto {
              file {
                url
              }
            }
          }
          category {
            title
          }
          isPressRelease
          date
        }
      }
    }
  }
`

export default deviceInfoProvider(BlogPage)
